const DEVELOPMENT_MODE = false;

window.BUY_API_URL = DEVELOPMENT_MODE
  ? "http://localhost:4001/api/buy_requests.json"
  : "https://api.discourse.org/api/buy_requests.json";

window.MIGRATIONS_API_URL = DEVELOPMENT_MODE
  ? "http://localhost:4001/api/migrations.json"
  : "https://api.discourse.org/api/migrations.json";

window.FREE_API_URL = DEVELOPMENT_MODE
  ? "http://localhost:4001/api/free.json"
  : "https://api.discourse.org/api/free.json";

window.BUY_REQUEST_SURVEY_ANSWERS_API_URL = DEVELOPMENT_MODE
  ? "http://localhost:4001/api/buy_requests/survey_answers.json"
  : "https://api.discourse.org/api/buy_requests/survey_answers.json";

window.STRIPE_PUBLIC_KEY = DEVELOPMENT_MODE
  ? "pk_test_X9dw0g9CEezhRzkXR3OB90aK"
  : "pk_live_WkI57yUhvaKQ88K9iTM0v1lk";
